module.exports = __webpack_public_path__ + "img/Notification.59297563.svg";